import { useGetCountry } from '#pplx/frontend/apps/ask/queries/cloudflare-queries/useGetCountry.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
export function useShowKoreanCompliance() {
    const country = useGetCountry();
    const { session } = useSession();
    const { env: { isProduction }, } = useWebPlatform();
    if (isProduction) {
        return country === 'KR';
    }
    // Non-production: opt-in via email suffix (e.g., user+korea@example.com)
    const email = session?.user?.email ?? '';
    return email.includes('+korea@');
}
//# sourceMappingURL=useShowKoreanCompliance.js.map